export default __webpack_public_path__ + "static/media/three.e56ac988.jpg";